export default __webpack_public_path__ + "static/media/sinal.77bb50bd.gif";